import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class HeaderDomesticSearchProxy extends ProxyBase {
  postHeaderDomesticSearch(params) {
    return this.post('search', params)
  }

  postHeaderSearchHistories(params) {
    return this.post('SearchHistories', params)
  }

  getHeaderSearchHistories(params) {
    return this.get('SearchHistories', params)
  }

  deleteHeaderSearchHistories(params) {
    return this.delete('SearchHistories', params)
  }
}

export default new HeaderDomesticSearchProxy('DomesticSearch/')
